<template>
	<div class="product">
		<ul class="uk-grid-match" uk-grid>
			<li class="uk-width-1-2@s">
				<div>
					<div class="product__image" uk-lightbox>
						<a :href="getFn()" :data-caption="'Цвет: ' + item.oprava_colors[currentColor].title + ' ' + getColorTitle()">
							<img :src="getFn()" alt="" uk-img>
						</a>
					</div>

					<div class="product__colors">
						<div class="catcard__colors">
							<ul class="uk-subnav uk-subnav-pill" uk-switcher>
								<li v-for="col, i in item.oprava_colors" class="catcard__color" :uk-tooltip="'Цвет ' + retColor(col, 'title')" :style="'background-color:' + retColor(col, 'code')" @click='currentColor = i'>
									<a href="#"></a></li>
							</ul>
						</div>
					</div>

					<!--<div class="product__accia uk-visible@s">На эту модель действует акция 3 + 1</div>-->
				</div>
			</li>
			<li class="uk-width-1-2@s">
				<div>
					<div class="product__head">
						<div class="product__title"><h1>Модель {{ item.title }}
              <small>серия {{ item.seria.title }}</small></h1>
						</div>

						<div class="product__logo" v-if="item.seria.brand.image">
							<img :src="item.seria.brand.image.path" alt="">
						</div>
					</div>
					<div class="product__properties props">

						<div class="props__item" v-if="user">
							<div class="props__title">Цена:</div>
							<div class="props__price">{{ showPrice | cifer }} ₽</div>
						</div>

						<div class="props__item" v-if="user">
							<div class="props__title">Цена указана со скидкой:</div>
							<div class="props__accia">{{ item.seria.discount }}%</div>
						</div>

						<div class="props__item" v-if="user">
							<div class="props__title">Количество:</div>
							<div class="props__count">
								<button uk-icon="minus" @click="minus"></button>
								<strong>{{ count }}</strong>
								<button uk-icon="plus" @click="plus"></button>
							</div>
						</div>

						<div class="props__item" v-if="user">
							<div class="props__title">Сумма:</div>
							<div class="props__sum">{{ showPrice * count | cifer }} ₽</div>
						</div>

					</div>

					<div class="product__button" v-if="!user">
						<div class="product__attent">Для того чтобы сделать заказ зарегистрируйтесь на сайте.<br>Или войдите в свою учетную запись.
						</div>
						<a :href="url + '/login'" class="product__addtocart">
							<img :src="url + '/themes/oprava/assets/img/ico-but1.svg'" alt="">
							<span>ВОЙТИ / ЗАРЕГИСТРИРОВАТЬСЯ</span>
						</a>
					</div>
					<div class="product__button" v-else>
						<button class="product__addtocart" @click="addToCart">
							<img :src="url + '/themes/oprava/assets/img/ico-button-cart.svg'" alt="">
							<span>ДОБАВИТЬ В КОРЗИНУ</span>
						</button>
					</div>


					<div class="product__descs">
						<ul uk-tab>
							<li><a href="#">Характеристики</a></li>
<!--							<li v-if="item.desc"><a href="#">Описание</a></li>-->
						</ul>
						<ul class="uk-switcher uk-margin">
							<li>
								<ul class="product__harki harki">
									<li><strong>Бренд:</strong> {{ item.seria.brand.title }}</li>
									<li v-if="item.oprava_colors[currentColor].color">
										<strong>Цвет:</strong> {{ item.oprava_colors[currentColor].title }} - {{ item.oprava_colors[currentColor].color.title }}
									</li>
									<li><strong>Размер окуляра:</strong> {{ item.occular_size }}</li>
									<li><strong>Размер переносицы:</strong> {{ item.nose_size }}</li>
									<li><strong>Пол:</strong> {{ joinProperties(item.genders) }}</li>
									<li><strong>Материал заушника:</strong> {{ joinProperties(item.hook_materials) }}</li>
									<li><strong>Материал окуляра:</strong> {{ joinProperties(item.materials) }}</li>
									<li><strong>Вид ободка:</strong> {{ joinProperties(item.rim_types) }}</li>
									<li><strong>Форма окуляра:</strong> {{ joinProperties(item.ocular_forms) }}</li>
									<li><strong>Наличие страз:</strong> {{ item.has_rhinestones ? 'Есть' : 'Нет' }}</li>
									<li v-if="item.seria.has_complect"><strong>Комплектация:</strong> Комплектуются футляром и салфеткой</li>
								</ul>
							</li>
<!--							<li v-if="item.desc">-->
<!--								<div class="product__description">-->
<!--									<p>{{ item.desc }}</p>-->
<!--								</div>-->
<!--							</li>-->
						</ul>
						<!--<div class="product__accia uk-hidden@s">На эту модель действует акция 3 + 1</div>-->
					</div>
				</div>
			</li>
		</ul>

    <div class="seo-block">
<!--      <h1>{{ item.title }} (серия {{ item.seria.title }})</h1>-->

<!--      <div class="product-description">-->
<!--        <h2>Описание</h2>-->
<!--        <p>-->
<!--          Оправы <strong>{{ item.seria.brand.title }}</strong> из {{ joinProperties(item.materials) }}.-->

<!--          Коллекция {{ product.year }} года. {{ product.equipment }}.-->

<!--        </p>-->
<!--      </div>-->

<!--      <div class="product-characteristics">-->
<!--        <h2>Характеристики</h2>-->
<!--        <ul class="product__harki harki">-->
<!--          <li><strong>Бренд:</strong> {{ item.seria.brand.title }}</li>-->
<!--          <li v-if="item.oprava_colors[currentColor].color">-->
<!--            <strong>Цвет:</strong> {{ item.oprava_colors[currentColor].title }} - {{ item.oprava_colors[currentColor].color.title }}-->
<!--          </li>-->
<!--          <li><strong>Размер окуляра:</strong> {{ item.occular_size }}</li>-->
<!--          <li><strong>Размер переносицы:</strong> {{ item.nose_size }}</li>-->
<!--          <li><strong>Пол:</strong> {{ joinProperties(item.genders) }}</li>-->
<!--          <li><strong>Материал заушника:</strong> {{ joinProperties(item.hook_materials) }}</li>-->
<!--          <li><strong>Материал окуляра:</strong> {{ joinProperties(item.materials) }}</li>-->
<!--          <li><strong>Вид ободка:</strong> {{ joinProperties(item.rim_types) }}</li>-->
<!--          <li><strong>Форма окуляра:</strong> {{ joinProperties(item.ocular_forms) }}</li>-->
<!--          <li><strong>Наличие страз:</strong> {{ item.has_rhinestones ? 'Есть' : 'Нет' }}</li>-->
<!--          <li v-if="item.seria.has_complect"><strong>Комплектация:</strong> Комплектуются футляром и салфеткой</li>-->
<!--        </ul>-->
<!--      </div>-->

<!--      <div class="purchase-conditions">-->
<!--        <h2>Условия покупки</h2>-->
<!--        <ul>-->
<!--          <li>Минимальный заказ — 7 000 ₽</li>-->
<!--          <li>Бесплатная доставка от 20 000 ₽</li>-->

<!--          {% if product.discount %}-->
<!--          <li>Специальное предложение: {{ product.discount }}</li>-->
<!--          {% endif %}-->

<!--        </ul>-->
<!--      </div>-->
    </div>

    <div class="seo-text" v-if="item.desc" v-html="item.desc">
    </div>
    <div class="seo-text" v-else>
      <h2>Оправы <strong>{{ item.title }}</strong> (серия {{ item.seria.title }}) от бренда <strong>{{ item.seria.brand.title }}</strong></h2>
<!--      <p>-->
<!--        {{ item.title }} — это {{ joinProperties(item.materials) }} оправы {{ joinProperties(item.genders) }}-->
<!--        из коллекции {{ new Date().getFullYear() }}. Размер окуляра {{ item.occular_size }} мм и переносицы {{ item.nose_size }} мм-->
<!--        обеспечивают комфортную посадку.-->
<!--      </p>-->
      <p>
        {{ joinProperties(item.genders) }} вариант оправ ({{ item.oprava_colors[currentColor].color.title }}).
        Удобный размер окуляра {{ item.occular_size }} мм и переносицы {{ item.nose_size }} мм обеспечивают комфортную посадку.
        <span v-if="item.seria.has_complect"> Комплектуются футляром и салфеткой</span>.
      </p>

      <h3>Почему выбирают {{ item.seria.brand.title }}?</h3>
      <ul>
        <li>Качественные материалы</li>
        <li>Заушник - {{ joinProperties(item.hook_materials) }}</li>
        <li>Окуляр - {{ joinProperties(item.materials) }}</li>
<!--        <li>Использование {{ joinProperties(item.materials) }} и {{ joinProperties(item.hook_materials) }}</li>-->
<!--        <li>Комплектация: футляр и салфетка в подарок</li>-->
      </ul>
    </div>
    <div class="seo-text">
      <h3>Условия покупки</h3>
      <p>
        Минимальный заказ — 7 000 ₽. Бесплатная доставка по РФ при заказе от 20 000 ₽.
        Отправка СДЭК или Почтой России. Возможен возврат части товара при получении.
      </p>
    </div>


    <div class="faq">
      <h3>Вопросы и ответы</h3>
      <details>
        <summary>Работаете ли вы с физическими лицами?</summary>
        <p>Мы работаем только с юридическими лицами.</p>
      </details>
      <details>
        <summary>Что делать, если я забыл (а) пароль?</summary>
        <p>Позвоните или напишите на WhatsApp по номеру телефона: +7 927 441 47 44, и Вам помогут.</p>
      </details>
      <details>
        <summary>Сколько отобранный товар может лежать в корзине?</summary>
        <p>Отобранный товар лежит в корзине 3 дня.</p>
      </details>
      <details>
        <summary>Я сделал (а) заказ, что дальше?</summary>
        <p>Как только Ваш заказ появиться на нашей электронной почте, с Вами свяжется наш менеджер. Не волнуйтесь, если это произойдет через какое-то время, менеджер может не сразу увидеть Ваш заказ.</p>
      </details>
      <details>
        <summary>Как производится оплата по выставленному счету?</summary>
        <p>Оплата производится ТОЛЬКО на расчётный счёт.</p>
      </details>
      <details>
        <summary>Счет оплачен. Как осуществляется доставка заказа?</summary>
        <p>Как только оплата поступит на наш счёт, в течении трёх дней, мы отправим Вам заказ до терминала транспортной компании СДЭК и Почты России. Заказ до 20 000 рублей отправляется за счёт покупателя, а с суммы 20 00 рублей и выше, за наш счёт.</p>
      </details>
      <details>
        <summary>Я не нашел (а) ответа на свой вопрос</summary>
        <p>На все интересующие вас вопросы, ответит менеджер по телефону: +7 927 441 47 44. Звоните или пишите на WhatsApp.</p>
      </details>
    </div>


  </div>
</template>

<script>
  import { bus } from './bus.js'
  import { product } from "../mixins/product";
  import { finance } from "../mixins/finance";
  import Swal from 'sweetalert2/dist/sweetalert2.js'

  export default {
    name: "product",
    mixins: [product, finance],
    data() {
      return {
        count: 1,
        currentColor: 0,
        prepay: ''
      }
    },
    props: {
      item: '',
      url: '',
      color: '',
      user: ''
    },
    methods: {
      getColorTitle() {
        let col;
        if (this.item.oprava_colors[this.currentColor].color) {
          col = this.item.oprava_colors[this.currentColor].color.title;
        } else {
          col = 'Цвет не определен';
        }
        return col;
      },
      joinProperties(arr) {
        if (arr.length == 1) {
          return arr[0].title;
        } else {
          let ret = [];
          arr.forEach(function (item, i, arr) {
            ret.push(item.title);
          });
          return ret.join(', ')
        }
      },
      getPrice() {
        return this.item.seria.price;
      },
      addToCart() {
        let app = this;
        let item = this.item;
        let count = this.count;
        let total = this.getPrice() * count;
        item.count = count;
        //item.total = total;
        //item.price = this.getPrice();
        item.currentColor = this.item.oprava_colors[this.currentColor];
        item.cart_id = item.id + '-' + item.currentColor.id;
        //delete item.oprava_colors;

        let fd = {
          item
        };

        //console.log(fd);
        $.request('onAddtoCart', {
          data: fd,
          success: function (data) {
            //... do something ...
            console.log(data);
            app.notify();
            bus.$emit('cart-reload', data.cart);
            //this.success(data);
          },
          error: function (err) {
            console.log(err);
          }
        })
      },
      notify() {
        let str = `Отлично! Товар добавлен в корзину`;
        Swal.fire({
          title: 'Товар добавлен',
          text: str,
          type: 'success',
          confirmButtonText: 'Хорошо'
        })
      },
      plus() {
        this.count++;
      },
      minus() {
        if (this.count > 1) {
          this.count--;
        }
      },
    },
    created() {
      this.prepay = this.getUserPrepay;
    }
  }
</script>


// WEBPACK FOOTER //
// themes/oprava/src/js/components/commerce/product.vue